/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Tags_Resultscount1Inputs */

const id_tags_resultscount1 = /** @type {(inputs: Tags_Resultscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} hasil)`)
};

const ms_tags_resultscount1 = /** @type {(inputs: Tags_Resultscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} hasil)`)
};

const da_tags_resultscount1 = /** @type {(inputs: Tags_Resultscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} resultater)`)
};

const de_tags_resultscount1 = /** @type {(inputs: Tags_Resultscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} Ergebnisse)`)
};

const en_us2_tags_resultscount1 = /** @type {(inputs: Tags_Resultscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} results)`)
};

const es_es2_tags_resultscount1 = /** @type {(inputs: Tags_Resultscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} resultados)`)
};

const es_mx2_tags_resultscount1 = /** @type {(inputs: Tags_Resultscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} resultados)`)
};

const fil_tags_resultscount1 = /** @type {(inputs: Tags_Resultscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} resulta)`)
};

const fr_tags_resultscount1 = /** @type {(inputs: Tags_Resultscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} résultats)`)
};

const it_tags_resultscount1 = /** @type {(inputs: Tags_Resultscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} risultati)`)
};

const hu_tags_resultscount1 = /** @type {(inputs: Tags_Resultscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} eredmény)`)
};

const nl_tags_resultscount1 = /** @type {(inputs: Tags_Resultscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} resultaten)`)
};

const no_tags_resultscount1 = /** @type {(inputs: Tags_Resultscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} resultater)`)
};

const pl_tags_resultscount1 = /** @type {(inputs: Tags_Resultscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} wyników)`)
};

const pt_br2_tags_resultscount1 = /** @type {(inputs: Tags_Resultscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(Resultados ${i?.count})`)
};

const pt_tags_resultscount1 = /** @type {(inputs: Tags_Resultscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} resultados)`)
};

const ro_tags_resultscount1 = /** @type {(inputs: Tags_Resultscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} rezultate)`)
};

const fi_tags_resultscount1 = /** @type {(inputs: Tags_Resultscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} tulosta)`)
};

const sv_tags_resultscount1 = /** @type {(inputs: Tags_Resultscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} resultat)`)
};

const vi_tags_resultscount1 = /** @type {(inputs: Tags_Resultscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} kết quả)`)
};

const tr_tags_resultscount1 = /** @type {(inputs: Tags_Resultscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} sonuç)`)
};

const cs_tags_resultscount1 = /** @type {(inputs: Tags_Resultscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} výsledků)`)
};

const bg_tags_resultscount1 = /** @type {(inputs: Tags_Resultscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} резултата)`)
};

const ru_tags_resultscount1 = /** @type {(inputs: Tags_Resultscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} результатов)`)
};

const uk_tags_resultscount1 = /** @type {(inputs: Tags_Resultscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} результатів)`)
};

const ar_tags_resultscount1 = /** @type {(inputs: Tags_Resultscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} نتيجة)`)
};

const hi_tags_resultscount1 = /** @type {(inputs: Tags_Resultscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} परिणाम)`)
};

const th_tags_resultscount1 = /** @type {(inputs: Tags_Resultscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} ผลลัพธ์)`)
};

const ja_tags_resultscount1 = /** @type {(inputs: Tags_Resultscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} 件の結果)`)
};

const zh_cn2_tags_resultscount1 = /** @type {(inputs: Tags_Resultscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} 个结果)`)
};

const zh_hant1_tags_resultscount1 = /** @type {(inputs: Tags_Resultscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} 個結果)`)
};

const ko_tags_resultscount1 = /** @type {(inputs: Tags_Resultscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(결과 ${i?.count}개)`)
};

/**
* | output |
* | --- |
* | "({count} results)" |
*
* @param {Tags_Resultscount1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const tags_resultscount1 = /** @type {((inputs: Tags_Resultscount1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Resultscount1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tags_resultscount1(inputs)
	if (locale === "ms") return ms_tags_resultscount1(inputs)
	if (locale === "da") return da_tags_resultscount1(inputs)
	if (locale === "de") return de_tags_resultscount1(inputs)
	if (locale === "en-US") return en_us2_tags_resultscount1(inputs)
	if (locale === "es-ES") return es_es2_tags_resultscount1(inputs)
	if (locale === "es-MX") return es_mx2_tags_resultscount1(inputs)
	if (locale === "fil") return fil_tags_resultscount1(inputs)
	if (locale === "fr") return fr_tags_resultscount1(inputs)
	if (locale === "it") return it_tags_resultscount1(inputs)
	if (locale === "hu") return hu_tags_resultscount1(inputs)
	if (locale === "nl") return nl_tags_resultscount1(inputs)
	if (locale === "no") return no_tags_resultscount1(inputs)
	if (locale === "pl") return pl_tags_resultscount1(inputs)
	if (locale === "pt-BR") return pt_br2_tags_resultscount1(inputs)
	if (locale === "pt") return pt_tags_resultscount1(inputs)
	if (locale === "ro") return ro_tags_resultscount1(inputs)
	if (locale === "fi") return fi_tags_resultscount1(inputs)
	if (locale === "sv") return sv_tags_resultscount1(inputs)
	if (locale === "vi") return vi_tags_resultscount1(inputs)
	if (locale === "tr") return tr_tags_resultscount1(inputs)
	if (locale === "cs") return cs_tags_resultscount1(inputs)
	if (locale === "bg") return bg_tags_resultscount1(inputs)
	if (locale === "ru") return ru_tags_resultscount1(inputs)
	if (locale === "uk") return uk_tags_resultscount1(inputs)
	if (locale === "ar") return ar_tags_resultscount1(inputs)
	if (locale === "hi") return hi_tags_resultscount1(inputs)
	if (locale === "th") return th_tags_resultscount1(inputs)
	if (locale === "ja") return ja_tags_resultscount1(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_resultscount1(inputs)
	if (locale === "zh-Hant") return zh_hant1_tags_resultscount1(inputs)
	return ko_tags_resultscount1(inputs)
});
export { tags_resultscount1 as "tags.resultsCount" }